(function () {
  if (window.htLively) return;
  window.htLively = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var symbol = document.documentElement.getAttribute('data-ht-currency') || '$';

  function money(cents) {
    return symbol + Math.round(cents / 100).toLocaleString('en-US');
  }

  function countUp(el) {
    var target = Number(el.getAttribute('data-ht-count')) || 0;
    if (reduce || target <= 0) { el.textContent = money(target); return; }
    var start = null;
    var duration = 1400;
    function step(t) {
      if (start === null) start = t;
      var p = Math.min((t - start) / duration, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = money(target * eased);
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function play(el) {
    el.classList.add('is-in');
    el.querySelectorAll('.ht-progress__fill').forEach(function (fill) {
      fill.style.width = fill.getAttribute('data-ht-width') || fill.style.width;
    });
    el.querySelectorAll('[data-ht-count]').forEach(countUp);
  }

  function setup(root) {
    var targets = root.querySelectorAll('.ht-card, .ht-goal, .ht-sec__head, .ht-case__side, .ht-marquee');
    if (!('IntersectionObserver' in window) || reduce) {
      targets.forEach(play);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        io.unobserve(entry.target);
        play(entry.target);
      });
    }, { threshold: 0.15 });
    targets.forEach(function (el, i) {
      if (el.classList.contains('ht-reveal')) return;
      el.querySelectorAll('.ht-progress__fill').forEach(function (fill) {
        fill.setAttribute('data-ht-width', fill.style.width);
        fill.style.width = '0%';
      });
      el.classList.add('ht-reveal');
      if (el.classList.contains('ht-card')) el.style.transitionDelay = (i % 3) * 90 + 'ms';
      io.observe(el);
    });
  }

  function chips(root) {
    root.querySelectorAll('[data-ht-chips]').forEach(function (grid) {
      var bar = grid.previousElementSibling;
      if (!bar || !bar.classList.contains('ht-chips') || grid.hasAttribute('data-ht-chips-ready')) return;
      grid.setAttribute('data-ht-chips-ready', '');
      var cards = grid.querySelectorAll(':scope > .ht-card');
      bar.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-ht-chip]');
        if (!btn) return;
        var i = Number(btn.getAttribute('data-ht-chip'));
        bar.querySelectorAll('[data-ht-chip]').forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        cards.forEach(function (c, j) { c.classList.toggle('is-active', j === i); });
        if (cards[i]) play(cards[i]);
      });
    });
  }

  // safety net: anything already on screen that didn't get revealed (e.g. page restored from cache)
  function sweep() {
    document.querySelectorAll('.ht-reveal:not(.is-in)').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) play(el);
    });
  }

  function init() { setup(document); chips(document); setTimeout(sweep, 1500); }
  window.addEventListener('pageshow', function () { setTimeout(sweep, 300); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function (e) { setup(e.target); chips(e.target); });
})();
